/**
 * @see https://stackoverflow.com/a/78230810/14447555
 * @todo use `userAgentData` when baseline ({@link https://developer.mozilla.org/en-US/docs/Web/API/Navigator/userAgentData|MDN})
 */
export function isMac() {
  return navigator.userAgent.toLowerCase().includes('mac');
}
